import React from 'react';
import { MoSpacing } from '@motivo/guanyin/src/components';
import { ResultOf } from ':src/graphql';
import { organizationAdminDetailsByIdQuery } from '../../graphql/queries';
import { SectionItem } from '../Section';
import { Typography } from '@mui/material';

type OrganizationAdmin = NonNullable<
  ResultOf<typeof organizationAdminDetailsByIdQuery>['organizationAdminById']
>;

interface BasicInfoProps {
  organizationAdmin: OrganizationAdmin;
}

export default function BasicInfo({ organizationAdmin }: BasicInfoProps) {
  const programs = organizationAdmin.organizationPrograms;

  return (
    <MoSpacing y={1}>
      <SectionItem label="Email">{organizationAdmin.email}</SectionItem>

      <SectionItem label="Role">{organizationAdmin.organizationRole.name}</SectionItem>

      {programs.length > 0 && (
        <SectionItem label="Programs">
          <MoSpacing y={0.5}>
            {programs.map((program) => (
              <Typography key={program.id}>{program.name}</Typography>
            ))}
          </MoSpacing>
        </SectionItem>
      )}
      {organizationAdmin.phone && (
        <SectionItem label="Phone">{organizationAdmin.phone}</SectionItem>
      )}
    </MoSpacing>
  );
}
